import * as React from 'react';

const defaultBranding = {};

export const BrandingContext = React.createContext(defaultBranding);